<template>
	<div class="qualityenterprise">
		<!-- <leftnav class="fl" mkcode="G" itemcode="A-QBNZQY" docutitle="重点产业招商"></leftnav> -->
		<div class="" :style="isCollapse?'margin-left: 0;width:100%':''">
			<!-- <govheader></govheader> -->
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle map_title_tab">
						<span class="title current">重点产业招商</span>
						
						<!-- <div class="fr search-box nz-search-box">
							<span class="searchtype">产业图谱库</span>
							<input type="text" placeholder="请输入产业关键词" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> -->
					</div>  
					<div class="opport-screen-list1">
						<!-- 产业概念细分筛选 -->
						<notionScreen 
						:type="2"  
						:notionNumberList="notionNumList"  
						:refreshNum="notionNumRefresh"
						:token="userdata.token" 
						@chooseNotion="chooseNotion" 
						:isShowNotionScreen="true"
						:isClearNotion="isClearNotion"
						:showNotionExtend="userdata.zsdn_version == 2"
						:showSimpleNotion="true"
						:isIntegration="isIntegration" 
						:ucomputer ="ucomputer"
						:defaultSelected="'simpleNotion'"
						:showFirstList="false"
						></notionScreen>
						<cityScreen @getEnterpriseList="cityScreenFun"></cityScreen>
						
						
						
					</div>
				</div>

				<div class="whitebox" style="min-height: 160px;">
					<preliminarySelection @chooseOption="chooseOption"></preliminarySelection>

					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<!-- <div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'"
							@click="enlistExport()" v-if="userdata.groupType == 1"
							v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
						</div> -->
					</div>
					<!-- 多维度分数筛选 全部内资企业删除排序功能-->
					<ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '" :key="index"
							v-for="(list,index) in dimensionList" @click="tablesort(list.type);"
							v-show="list.name!='融资时间'||searchtype == 2">
							<span :class="orderField == list.type ?'sortname current ':'sortname '">{{list.name}}</span>
							<span :class="ordertype == 1?'timesorticon up':'timesorticon down'"></span>
						</li>
					</ul>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td>{{(page-1)*pageSize+i+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b
							class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script>
	import { dataInJs } from "@/utils/city.js";
import { data } from "jquery";
	import { mapState, mapMutations, mapGetters } from "vuex";
	
	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite:this.$api.getWebsiteType(),
				title: "全部内资企业",
				searchPlaceholder: '请输入企业名称',
				fenkd: {
					children: []
				},
				curindex: 6,
				childrenEnterinArr:[
					{P_type: 0,type: 0,name: "全部",},
					{P_type: 1,type: 9,name: "A股上市龙头企业",},
					{P_type: 1,type: 'A090206',name: "港股中资企业",},
					{P_type: 1,type: 'A090208',name: "美股中资企业",},
					{P_type: 1,type: 1,name: "非上市龙头企业",},
					{P_type: 2,type: 2,name: "创投企业",},
					{P_type: 2,type: 3,name: "优质企业",}
				],
				enterinarr: [
					{curindex: 1,type: 9,name: "龙头企业库",tagnum: 10010,},
					{curindex: 2,type: 2,name: "科创企业库",tagnum: 10010,},
				],
				tz_enterinarr: [{
						pagecode: 'A-CXQY',
						type: 2,
						name: "创新企业",
						tagnum: 3,
						hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
					},
					{
						pagecode: 'A-YZQY',
						type: 3,
						name: "优质企业",
						tagnum: 10009,
						hxtagname: '&拿地信息&股权投资信息&'
					},
				],
				userdata: {token:''},
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0],
				searchtype: 0,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				notionNumRefresh:1,
				isClearNotion:false,
				notionNumList:[],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0,
				cityid: 0,
				countyid: 0, 
				citydata: [],
				countydata: [],
				fontb: {
					fontWeight: 'bold'
				},
				initialTagdata: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				qyslitagCom: [], //公共科技实力
				qyslitagPublicselect: [], //公共科技实力下拉框版
				comSearchdata: [0, 'empty', 'empty', 'empty'], //公共科技实力下拉框版 存储值
				qysltagUnique: [], //独有企业实力（全部内资企业集合 上市公司和优质企业的企业实力） 
				totalqysl:[],
				financing_rounds:[],//融资轮次标签
				investRound:'',//融资轮次
				totalqysl_shangshi: [ ],
				totalqysl_youzhi: [ ],
				searchtagdata: ['0'],
				enterpristlist: [],
				usertaglist: [],
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				ordertype: 0, //排序方式 0 降序 1 升序   
				commontagcode: 0,
				tyinitialTagdata: [],
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				notionstep: 0,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}, {
					name: '控制企业',
					type: 10
				}, ],
				isIntegration:true,
				ucomputer:false, //不计算概念数量，港股和美股暂无数据所以不计算
				showTipsType:3,
				isShowFreeUserTips:false,
				provinceid: 0,
				cityid: 0,
				countyid: 0, 
				citydata: [],
				countydata: [],
				score1: 0,
				score2: 0,
				score3: 0,
				strategy: '',
				site: '',
				operate: '',
			}
		},
		beforeCreate() {
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			}); 
			this.userdata = this.getuseriformation() || {};
			this.$emit('loading', true);
		},
		mounted() { 
			 this.ajaxsearchcompany();
		},
		methods: {
			chooseOption(strategy, site, operate, score1, score2, score3) {
				this.strategy = strategy;
				this.site = site;
				this.operate = operate;
				this.score1 = score1;
				this.score2 = score2;
				this.score3 = score3;
				this.ajaxsearchcompany(1);
			},
			 //省份城市选择
			cityScreenFun(pid,cid,cuid){
				this.cityid = cid;
				this.countyid = cuid; 
				this.provinceid = pid;
				this.ajaxsearchcompany(1, 'sort');
			},
			getajaxUrl(apiurl, searchtype) {
				let ajaxurl = '';
				var notionja = this.splicing('notion', this.notionCode);
				ajaxurl = apiurl + '?type=' + this.searchtype +  notionja+'&search=1';
				return ajaxurl
			},
			//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				} 
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export(), 'search') + '&token=' + this.userdata
					.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					console.log('一分钟冷却计时')
				}, 60000)
			},
			//时间/分数升降序
			tablesort(field) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if (field == this.orderField) {
					this.ordertype = Math.abs(this.ordertype - 1);
				} else {
					this.orderField = field;
				}
				this.ajaxsearchcompany();
			},
			//搜索关键词
			searchkwfun() {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				if (this.searchtext.length > 0) {
					var pathque = {
						kw: this.searchtext
					};
					this.routerlinkarry('/totalSearch', pathque);
				} else {
					this.$message({
						type: 'error',
						message: '请输入关键词搜索',
					});
				}
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
 
			pageHandler: function(page) {
				this.ajaxsearchcompany(page, 'sort', 'search');
			},			//清空概念选项
			clearNotion() {
				this.notionNumRefresh++;
				this.isClearNotion=true; 
				this.notionCode = 0;
			},
			//概念单选 层级显示
			chooseNotion(chooseNotionlist,notionCode,step){ 
				this.notionCode=notionCode;  
				if(step){
					this.notionstep = step; 
				}
				var sortStr =  (step && step < 3) ? 'sort':''; 
				if(step && step < 3){
					sortStr = 'sort';
				}else if(step && step <4 && this.isIntegration){
					if(this.notionCode.indexOf('B')>-1||this.notionCode.indexOf('D')>-1||this.notionCode.indexOf('E')>-1||this.notionCode.indexOf('F')>-1){
						sortStr = 'sort';
					}
				}
				this.ajaxsearchcompany(1,sortStr); 
			},
			
			ajaxsearchcompany(pages, citytype, searchtype) {
				console.log('搜索企业',pages, citytype, searchtype);
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var _this = this; 
				var countyidja = this.splicing('county', this.countyid);
				var provinceidja = this.splicing('province', this.provinceid);
				var cityidja = this.splicing('city', this.cityid);
				var score1ja = this.splicing('score1', this.score1);
				var score2ja = this.splicing('score2', this.score2);
				var score3ja = this.splicing('score3', this.score3);
				var orderFieldja = this.splicing('orderField', this.orderField);
				var orderTypeja = this.splicing('orderType', this.ordertype);
				var siteja = this.splicing('site', this.site);
				var operateja = this.splicing('operate', this.operate);
				var strategyja = this.splicing('strategy', this.strategy);
				var isnotiontoggle = citytype == 'sort' && this.notionCode != 0 && !this.ucomputer; 
				var calcnc = isnotiontoggle ? '&calNotion=1&calCNC=1' :''; 
				// var notionstepd = this.notionstep;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.investclue.keyIndustry()) + '&page=' + this.page + countyidja + provinceidja + cityidja
				+ score1ja + score2ja + score3ja + orderFieldja + orderTypeja + siteja + operateja + strategyja;
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('企业列表',ajaxurl, res.data);
					if (res.data.success) {
						var dataenterlist = res.data.list; 
						for (var i = 0; i < res.data.list.length; i++) {
							dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[
								i].notionCode, 'notionsort');
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
								.tagCode);
						}
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize;
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext;
						_this.exportbtn = true;
						_this.confirmtext = "确认导出";
						_this.enterpristlist = dataenterlist;
						_this.bus.$emit('loading', false);
						 
					}  
				}).catch(function(error) {});
				// console.log(datas);  
			},
			//  
		}
	}
</script>

<style lang="scss" scoped>

</style>